import React, { useState } from "react"

import IconButton from "@mui/material/IconButton"
import InputAdornment from "@mui/material/InputAdornment"

import CloseIcon from "@mui/icons-material/Close"

import { DesktopDatePicker } from "@mui/x-date-pickers"
import { TextField } from "@mui/material"

/**
 *
 * @param {Omit<import('@mui/x-date-pickers').DesktopDatePickerProps, 'renderInput' | 'onChange'> & {sx?: import('@mui/material').SxProps, error?: boolean, name?: string, clearable?: boolean, id?: string, textField?: import("@mui/material").TextFieldProps, InputLabelProps?: import('@mui/material').InputLabelProps, onChange?: (value: any, keyboardInputValue?: string) => void; size?: import("@mui/material").TextFieldProps['size']}} props
 * @returns
 */
export const DatePicker = ({
  value,
  error,
  onChange = () => {},
  onAccept,
  onClose,
  id,
  label,
  name,
  clearable,
  clearableSize = "medium",
  calendarIconSize,
  sx,
  InputLabelProps,
  textField = {},
  size = "medium",
  PopperProps,
  ...rest
}) => {
  const [open, setOpen] = useState(false)

  const handleAccept = (val) => {
    if (onAccept && !isNaN(val)) {
      onAccept(val)
    }

    setOpen(false)
  }

  const handleClose = () => {
    onClose?.()
    setOpen(false)
  }

  return (
    <DesktopDatePicker
      {...rest}
      open={open}
      closeOnSelect
      showToolbar
      value={value}
      onChange={onChange}
      onAccept={handleAccept}
      onClose={handleClose}
      PopperProps={{ id: "date-picker", ...PopperProps }}
      renderInput={(props) => {
        return (
          <TextField
            fullWidth
            {...props}
            size={size}
            sx={[
              ...(Array.isArray(sx) ? sx : [sx]),
              calendarIconSize === "small" && {
                ".MuiInputAdornment-root .MuiIconButton-root": { padding: 0.5 },
                ".MuiInputAdornment-root .MuiSvgIcon-root": {
                  fontSize: "1.1rem"
                }
              }
            ]}
            id={id}
            name={name}
            label={label}
            error={error ?? (!!value && props.error)}
            {...textField}
            onClick={() => setOpen(true)}
            onBlur={(e) => {
              props.onBlur?.(e)
              if (onAccept && !isNaN(value)) {
                onAccept(value)
              }
            }}
            InputLabelProps={InputLabelProps}
            InputProps={{
              ...rest.InputProps,
              endAdornment:
                clearable && value ? (
                  <>
                    <InputAdornment position="end">
                      <IconButton
                        size={clearableSize}
                        onClick={(e) => {
                          e.stopPropagation()
                          onChange(null)
                          onAccept?.(null)
                        }}
                      >
                        <CloseIcon fontSize={clearableSize} />
                      </IconButton>
                    </InputAdornment>
                    {rest.InputProps?.endAdornment}
                    {props.InputProps?.endAdornment}
                  </>
                ) : (
                  <>
                    {rest.InputProps?.endAdornment}
                    {props.InputProps.endAdornment}
                  </>
                )
            }}
          />
        )
      }}
    />
  )
}
